import Model, { attr, hasMany } from '@ember-data/model';
import MailchimpFundSettingModel from './mailchimp-fund-setting';

export default class MailchimpSettingModel extends Model {
  @attr() lists: any;
  @hasMany('mailchimp-fund-setting', { async: false, inverse: null })
  fundSettings?: MailchimpFundSettingModel[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'mailchimp-setting': MailchimpSettingModel;
  }
}
